import React from 'react';
import { Hexagon, Play, Pause, Share2, User, ChevronDown, CheckCircle2 } from 'lucide-react';
export function TopBar() {
  return <header className="h-14 w-full bg-[#070b14]/90 backdrop-blur-md border-b border-slate-800/60 flex items-center justify-between px-4 z-20 shrink-0" data-id="element-135">
      {/* Left: Logo & Nav */}
      <div className="flex items-center gap-8" data-id="element-136">
        <div className="flex items-center gap-2 text-sky-400" data-id="element-137">
          <Hexagon className="w-6 h-6 fill-sky-400/20" data-id="element-138" />
          <span className="font-bold text-lg tracking-wide text-slate-100" data-id="element-139">
            AgentVerse
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-1 text-sm font-medium text-slate-400" data-id="element-140">
          <button className="px-3 py-1.5 rounded-md bg-slate-800/50 text-sky-400" data-id="element-141">
            Builder
          </button>
          <button className="px-3 py-1.5 rounded-md hover:text-slate-200 hover:bg-slate-800/30 transition-colors" data-id="element-142">
            Marketplace
          </button>
          <button className="px-3 py-1.5 rounded-md hover:text-slate-200 hover:bg-slate-800/30 transition-colors" data-id="element-143">
            Agents
          </button>
          <button className="px-3 py-1.5 rounded-md hover:text-slate-200 hover:bg-slate-800/30 transition-colors" data-id="element-144">
            Runs
          </button>
          <button className="px-3 py-1.5 rounded-md hover:text-slate-200 hover:bg-slate-800/30 transition-colors" data-id="element-145">
            Settings
          </button>
        </nav>
      </div>

      {/* Center: Agent Status */}
      <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-146">
        <div className="flex items-center gap-2" data-id="element-147">
          <h1 className="font-semibold text-slate-200" data-id="element-148">Morning Email Agent</h1>
          <ChevronDown className="w-4 h-4 text-slate-500 cursor-pointer hover:text-slate-300" data-id="element-149" />
        </div>
        <div className="flex items-center gap-2 text-[11px] mt-0.5" data-id="element-150">
          <div className="flex items-center gap-1 text-emerald-400 bg-emerald-400/10 px-1.5 py-0.5 rounded-full border border-emerald-400/20 glow-emerald" data-id="element-151">
            <span className="relative flex h-1.5 w-1.5" data-id="element-152">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-153"></span>
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500" data-id="element-154"></span>
            </span>
            Running
          </div>
          <span className="text-slate-500" data-id="element-155">Last run: 2 min ago</span>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-3" data-id="element-156">
        <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-slate-800 hover:bg-slate-700 text-slate-300 text-sm font-medium transition-colors border border-slate-700" data-id="element-157">
          <Pause className="w-4 h-4" data-id="element-158" />
          <span data-id="element-159">Pause</span>
        </button>
        <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-sky-500 hover:bg-sky-400 text-slate-950 text-sm font-semibold transition-colors glow-sky" data-id="element-160">
          <Play className="w-4 h-4 fill-current" data-id="element-161" />
          <span data-id="element-162">Run Now</span>
        </button>
        <div className="w-px h-6 bg-slate-800 mx-1" data-id="element-163"></div>
        <button className="p-1.5 text-slate-400 hover:text-slate-200 transition-colors" data-id="element-164">
          <Share2 className="w-5 h-5" data-id="element-165" />
        </button>
        <button className="w-8 h-8 rounded-full bg-gradient-to-tr from-sky-500 to-indigo-500 flex items-center justify-center text-white border-2 border-slate-900 ml-1" data-id="element-166">
          <User className="w-4 h-4" data-id="element-167" />
        </button>
      </div>
    </header>;
}